import React from 'react';
import { ArrowRight, BarChart3 } from 'lucide-react';
import ProblemSelector from './ProblemSelector';
import { useInView } from '../hooks/useInView';

interface PainPointsSectionProps {
  handleCTAClick: (e: React.MouseEvent) => void;
}

const PainPointsSection: React.FC<PainPointsSectionProps> = ({ handleCTAClick }) => {
  const [sectionRef, inView] = useInView();
  
  return (
    <section 
      id="pain-points"
      className="section-padding bg-white relative"
    >
      <div ref={sectionRef} className={`container relative z-10 fade-up ${inView ? 'in-view' : ''}`}>
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="bg-white rounded-3xl shadow-lg p-8 space-y-8">
              <h2 className="text-3xl md:text-4xl font-bold">
                Kommt Ihnen das bekannt vor?
              </h2>
              
              <div className="space-y-4">
                {[
                  'Recruitingkosten steigen – qualifizierte Bewerber bleiben aus',
                  'Krankheitsausfälle erreichen Rekordwerte und belasten Ihr Team',
                  'Hohe Fluktuation kostet Know-how und treibt Budget in die Höhe',
                  'Einmalige Boni verpuffen schnell, Motivation sinkt erneut',
                  'Staatliche Fördergelder bleiben ungenutzt, weil Zeit & Know-how fehlen',
                  'Ein ganzheitliches System, das alle Mitarbeitenden erreicht, fehlt'
                ].map((point, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-100 flex items-center justify-center">
                      <span className="text-red-500 font-bold">✕</span>
                    </div>
                    <span className="text-gray-700">{point}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <p className="text-lg text-gray-900 font-medium px-4">
              Talente erwarten heute mehr als Gehalt und spannende Aufgaben. Sie 
              bleiben dort, wo spürbarer Mehrwert ihre persönlichen Bedürfnisse trifft – 
              und entscheiden sich für Arbeitgeber, die genau das bieten.
            </p>
            
            <button 
              onClick={handleCTAClick}
              className="btn btn-primary btn-lg inline-flex items-center gap-2 ml-4"
            >
              Werde zum top Arbeitgeber
              <ArrowRight size={20} />
            </button>
          </div>
          
          <div>
            <ProblemSelector handleCTAClick={handleCTAClick} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainPointsSection;